import { Vue, i18n } from "Common/vue";

// import components
import Autocomplete from "VueComponents/Autocomplete.vue";
import Minicart from "VueComponents/Minicart.vue";

import "Ui/toggle";
import "Components/navigation-menu-aim";
import "Common/sticky-header";
import "Common/camera-scanner";
// V appke presmeruje EAN triggery na natívny SCAN_BARCODE — musí byť za camera-scanner
import "Common/camera-scanner-app";

if (document.querySelector(".js-vue-autocomplete")) {
    window.$_autocomplete = new Vue({
        i18n,
        render: (h) => h(Autocomplete),
    }).$mount(".js-vue-autocomplete");
}

if (document.querySelector(".js-vue-minicart")) {
    window.$_minicart = new Vue({
        i18n,
        render: (h) => h(Minicart),
    }).$mount(".js-vue-minicart");
}

const categoriesFilterEl = document.querySelector(".js-vue-categories-filter");
if (categoriesFilterEl) {
    const productsCategories = categoriesFilterEl.dataset.categories,
        selectedCategoryId = categoriesFilterEl.dataset.selected,
        visibleCategories = categoriesFilterEl.dataset.visibleCategories;

    new Vue({
        el: ".js-vue-categories-filter",
        components: {
            CategoriesFilter: () => import("VueComponents/CategoriesFilter.vue"),
        },
        template: `
          <CategoriesFilter :select-category-id="${selectedCategoryId}"
                            :visible-categories="${visibleCategories}" :products-categories="${productsCategories}"></CategoriesFilter>`,
    });
}

const triggerSearchEl = document.querySelector(".js-trigger-search");
if (triggerSearchEl) {
    triggerSearchEl.addEventListener("click", (event) => {
        event.preventDefault();

        window.scroll({
            top: 0,
            left: 0,
            behavior: "instant",
        });

        rEvent.dispatch("Autocomplete.showForm");
    });
}
